const ALGORITHMS: any = [
    {
        code: 'algorithm_level1',
        title: 'algorithm_level1',
    },
    {
        code: 'algorithm_level1_mix',
        title: 'algorithm_level1_mix',
    },
    {
        code: 'algorithm_level1_mix_big',
        title: 'algorithm_level1_mix_big',
    },
    {
        code: 'algorithm_level2',
        title: 'algorithm_level2',
    },

    // Chưa chay level3
    // {
    //     code: 'algorithm_level3',
    //     title: 'algorithm_level3',
    // },
    // {
    //     code: 'algorithm_level3_so_am',
    //     title: 'algorithm_level3_so_am',
    // },
    // {
    //     code: 'algorithm_level3_thap_phan',
    //     title: 'algorithm_level3_thap_phan',
    // },

    {
        code: 'algorithm_level4_one',
        title: 'algorithm_level4_one',
    },
    {
        code: 'algorithm_level4_two',
        title: 'algorithm_level4_two',
    },
    {
        code: 'algorithm_level4_three',
        title: 'algorithm_level4_three',
    },
    {
        code: 'algorithm_level4_four',
        title: 'algorithm_level4_four',
    },
    {
        code: 'algorithm_level4_five',
        title: 'algorithm_level4_five',
    },
    {
        code: 'algorithm_level4_six',
        title: 'algorithm_level4_six',
    },
    {
        code: 'algorithm_level4_division_one',
        title: 'algorithm_level4_division_one',
    },
    {
        code: 'algorithm_level4_division_two',
        title: 'algorithm_level4_division_two',
    },
    // {
    //     code: 'algorithm_level4_division_three',
    //     title: 'algorithm_level4_division_three',
    // },
];

export default ALGORITHMS;


// WEBPACK FOOTER //
// ./src/constants/ALGORITHMS.ts